import React, { useRef, useState } from "react";
import ReactVimeo from "@u-wave/react-vimeo";
import cs from "classnames";
import PropTypes from "prop-types";
import classes from "./Player.module.scss";
import { useVimeoActivity } from "../../../activity/hooks";

const Player = ({
  additionalClass,
  page,
  playerSize,
  onTimeUpdate,
  disableForward = false,
  activity,
  onReady,
  ...props
}) => {
  const vimeoRef = useRef(null);
  const maxTimeRef = useRef(0);
  const [vimeoPlayer, setVimeoPlayer] = useState(null);

  // Reports the member's playback of `activity` - the library content playing (src/activity).
  // Without it, as for promotional videos, nothing is reported.
  useVimeoActivity(vimeoPlayer, activity);

  const handleReady = (player) => {
    setVimeoPlayer(player);
    if (onReady) {
      onReady(player);
    }
  };
  const addClasses = () => {
    if (page == "library") {
      return classes.library;
    }
    if (page == "kids") {
      return classes.kidsLayout;
    }
    if (page == "illuminate") {
      return classes.illuminate;
    }
    if (page == "daily-rebbe-video") {
      return classes.dailyRebbeVideo;
    }
    if (page == "writingCompetition") {
      return classes.writingCompetition;
    }
    return classes[page];
  };

  const handleTimeUpdate = (event) => {
    if (disableForward) {
      // If the user scrubbed forward by more than 1.5 seconds, bring them back.
      if (
        event.seconds > maxTimeRef.current &&
        event.seconds - maxTimeRef.current > 1.5
      ) {
        if (vimeoRef.current && vimeoRef.current.player) {
          vimeoRef.current.player.setCurrentTime(maxTimeRef.current);
        }
      } else {
        if (event.seconds > maxTimeRef.current) {
          maxTimeRef.current = event.seconds;
        }
      }
    }
    if (onTimeUpdate) {
      onTimeUpdate(event);
    }
  };

  return (
    <div className={cs(classes.container, addClasses())}>
      <ReactVimeo
        ref={vimeoRef}
        className={cs(
          classes.player,
          classes[additionalClass],
          classes[playerSize]
        )}
        {...props}
        autoplay
        color="#bf3c48"
        onTimeUpdate={handleTimeUpdate}
        onReady={handleReady}
      />
    </div>
  );
};

Player.propTypes = {
  additionalClass: PropTypes.string,
  page: PropTypes.string,
  playerSize: PropTypes.string,
  onTimeUpdate: PropTypes.func,
  disableForward: PropTypes.bool,
  activity: PropTypes.shape({
    type: PropTypes.oneOf(["video", "audio"]).isRequired,
    id: PropTypes.number.isRequired,
    startSeconds: PropTypes.number,
    endSeconds: PropTypes.number,
  }),
  onReady: PropTypes.func,
};

Player.defaultProps = {
  additionalClass: "",
  page: "",
};

export default React.memo(Player);
